
















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class ExpandableCard extends Vue {
@Prop({ required: true }) title!: string;
@Prop() icon?: string;
@Prop({ default: false }) initiallyExpanded!: boolean;
@Prop({ default: false }) disabled!: boolean;

// initialize respecting disabled state
expanded: boolean = (this.initiallyExpanded && !this.disabled) as boolean;

collapse() {
  this.expanded = false;
}

expand() {
  if (this.disabled) return;
  this.expanded = true;
}

toggleExpand() {
  if (this.disabled) return;
  this.expanded = !this.expanded;
}

onTitleClick() {
  this.toggleExpand();
}

@Watch('disabled')
onDisabledChanged(val: boolean) {
  if (val) {
    // ensure card is not expanded when disabled
    this.collapse();
  }
}
}
